var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product"},[_c('banner',{attrs:{"bannerType":_vm.product}}),_vm._v(" "),_c('team',{attrs:{"hideTitle":true}}),_vm._v(" "),_c('div',{staticClass:"white"}),_vm._v(" "),_c('pagesBottom',{attrs:{"page-index":_vm.currentPage,"total":_vm.count,"page-size":_vm.pageSize},on:{"change":_vm.pageChange}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4220275b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/partner/partner.vue
// module id = null
// module chunks = 